module.exports = __webpack_public_path__ + "static/media/compose.e95f084e.svg";